import { ISidenavMenuItem } from './sidenav-menu-item.interface';

/**
 * A class to represent a sidenav menu divider
 */
export class SidenavMenuDivider implements ISidenavMenuItem {
  public type = 'divider';
}
